import { useEffect, useState } from 'react'

type Callback = (...args: any[]) => Promise<any>
type Loader = (...args: any[]) => boolean

const createAsyncData =
  (fn: Callback): Loader =>
  (...args) => {
    const [loading, setLoading] = useState(true)
    useEffect(() => {
      ;(async function loadData() {
        setLoading(true)
        await fn(...args)
        setLoading(false)
      })()
    }, args) // eslint-disable-line react-hooks/exhaustive-deps

    return loading
  }

export default createAsyncData
